<report-filter 
  showCostCenters=true
  showFacilities=true
  showShiftBlocks=true
  showPeriodEndDateSelection=true
  showViews='true'
  reportType='ancillary'
  ancillaryType='acuity'
  [(views)]="views"
  [defaultView] = "defaultView"
  [(defaultFilter)]="filters"
  (filterUpdated)="filterUpdated($event)"
  defaultPayPeriodsBack=1>
</report-filter>

<smt-acuity-trends-report
  [filtersUpdated]='filterEventsSubject.asObservable()' 
  (dataUpdated)='dataUpdated($event)'
  [(reportFilters)]='filters'>
</smt-acuity-trends-report>

<report-export-button
[reportFilters]="filters"
[exportUrl]="'Acuity/GetAcuityTrendsReportExportData'"
[fileName]="'Activity_Trends_Report'"
[filtersUpdated]='filterEventsSubject.asObservable()'>
</report-export-button>
<table *ngIf='displayGrid()' class='condensed' role='list'>
    <thead>
      <th><!-- empty row for the series names --></th>
      <th *ngFor='let item of data.xAxis'><div>{{item}}&nbsp;&nbsp;</div></th>
    </thead>
    <tr *ngFor='let dataSet of chartData'>
      <td>{{dataSet.name}}</td> 
      <td *ngFor='let item of dataSet.data'>{{formatValue(item)}}</td>
    </tr>
  </table>
